import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import Radio             from '@mui/material/Radio'
import RadioGroup        from '@mui/material/RadioGroup'
import FormControlLabel  from '@mui/material/FormControlLabel'
import ArrowForwardIcon  from '@mui/icons-material/ArrowForward'
import store             from '../../store'
import '../../App.css'
import '../../style.css'

function GameStart({ startYesNo, setStartYesNo }) {
  const gameModeSelect = store.getState().GameModeSelect
  const calcSelect     = store.getState().CalcSelect

  // 計算式の判定
  const getCalcModeText = (calcSelect) => {
    switch (calcSelect) {
      case 'tashi':
        return 'たしざん'
      case 'hiki':
        return 'ひきざん'
      case 'kake':
        return 'かけざん'
      default:
        return ''
    }
  }

  // ラジオ変更時
  const handleRadioChange = (event) => {
    const value = event.target.value
    setStartYesNo(value)                   // 親(GBUI)の state を更新
    store.getState().SelectYesNo = value   // 互換用に store にも反映
    console.log('GameStart 選択中のラベル:', value)
  }

  return (
    <Box sx={{ m: 1, p: 4 }}>
      {/* 画面 */}
      <Paper
        sx={{
          m: 1,
          p: 1,
          bgcolor: '#f5f5dc',
          borderRadius: '1px',
          height: '250px',
          width: '250px',
          position: 'absolute',
          top: '20px',
          left: '40px',
        }}
      >
        <Grid container spacing={0}>
          {/* タイトル表示 */}
          {/* 国語or算数、タイピングゲームで表示内容を変更 */}
          <Grid item xs={12} align="center">
            <Typography
              sx={{
                fontFamily: 'DotGothic16',
                fontSize: '25px',
                color: '#000000',
              }}
            >
            {store.getState().GameModeSelect === 'typing'
                ? 'タイピングゲーム'
                :
              `${store.getState().GameModeSelect === 'kokugo'
                ? 'こくご'
                : store.getState().GameModeSelect === 'sansuu'
                ? 'さんすう'
                : store.getState().GameModeSelect}
                のもんだい`}
            </Typography>
          </Grid>

          {/* けいさんモード or 学年の表示 */}
          {/* タイピングゲームの場合は表示しない */}
          <Grid item xs={12} align="center">
            {gameModeSelect === 'typing' ? null : gameModeSelect === 'sansuu' ? (
              <Typography
                sx={{
                  fontFamily: 'DotGothic16',
                  fontSize: '15px',
                  color: '#000000',
                }}
              >
                (けいさんモード：{getCalcModeText(calcSelect)})
              </Typography>
            ) : (
              <Typography
                sx={{
                  fontFamily: 'DotGothic16',
                  fontSize: '15px',
                  color: '#000000',
                }}
              >
                (出てくるかんじ：{store.getState().GakunenSelect}ねんせい)
              </Typography>
            )}
          </Grid>

          {/* YES / NO 選択欄表示 */}
          <Grid item xs={12} align="center">
            <Box
              sx={{
                fontFamily: 'DotGothic16',
                color: '#000000',
                border: '3px solid #696969',
                borderRadius: '5px',
                padding: '0 5px',
                top: '115px',
                left: '152px',
                position: 'absolute',
              }}
            >
              <RadioGroup
                name="radio-buttons-group"
                value={startYesNo}
                onChange={handleRadioChange}
              >
                <FormControlLabel
                  value="yes"
                  control={
                    <Radio
                      icon={
                        <ArrowForwardIcon style={{ color: '#f5f5dc' }} />
                      }
                      checkedIcon={
                        <ArrowForwardIcon style={{ color: '#000000' }} />
                      }
                    />
                  }
                  label="はい"
                  sx={{ marginBottom: '-3px' }}
                  tabIndex={0}
                />
                <FormControlLabel
                  value="no"
                  control={
                    <Radio
                      icon={
                        <ArrowForwardIcon style={{ color: '#f5f5dc' }} />
                      }
                      checkedIcon={
                        <ArrowForwardIcon style={{ color: '#000000' }} />
                      }
                    />
                  }
                  label="いいえ"
                  sx={{ marginTop: '-3px' }}
                  tabIndex={0}
                />
              </RadioGroup>
            </Box>
          </Grid>

          {/* メッセージ欄表示 */}
          <Grid
            item
            xs={12}
            align="center"
            sx={{
              border: '3px solid #696969',
              borderRadius: '5px',
              padding: '0 5px',
              top: '200px',
              left: '5px',
              position: 'absolute',
              width: '96%',
              height: '23%',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'DotGothic16',
                fontSize: '12px',
                color: '#000000',
              }}
              tabIndex={0}
            >
              {store.getState().GameModeSelect === 'typing'
                ? 'タイピングゲームをはじめますか？'
                : `${store.getState().GameModeSelect === 'kokugo'
                ? 'こくご'
                : store.getState().GameModeSelect === 'sansuu'
                ? 'さんすう'
                : store.getState().GameModeSelect}
              のもんだいをはじめますか？`}
                <br />
              1.クリック or ↑↓でえらぶ
              <br />
              2.Aボタンでけってい
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Grid container spacing={2}>
        <Grid item xs={12} align="center"></Grid>
      </Grid>
    </Box>
  )
}

export default GameStart
